import { DAY_KEYS, type DayKey } from "@/lib/days";
import type { PainLogConfig, PainLogDayData } from "@/lib/schema";

// Reads the week row's mirror, never the Pain entry itself: every scoring
// path in the app scores synchronously from the snapshot (docs/adr/0028).
export function scoreDay(config: PainLogConfig, dayData: unknown): number {
  const data = (dayData ?? {}) as PainLogDayData;
  return data.level === true ? config.points : 0;
}

export function scoreWeek(
  config: PainLogConfig,
  runtime: { week: unknown; days: Record<DayKey, unknown> },
): number {
  let total = 0;
  for (const k of DAY_KEYS) total += scoreDay(config, runtime.days[k]);
  return total;
}

export function maxScoreWeek(config: PainLogConfig): number {
  return 7 * config.points;
}
